import Image from "next/image";

import { mergeClasses } from "@trex-2b/libs";

export type LandingStepSlide = {
  stepLabel: string;
  heading: string;
  description: string;
  image: string;
};

export type LandingStepSlideCardProps = {
  slide: LandingStepSlide;
  index: number;
  className?: string;
};

/**
 * Figma `8788:9952` row: left copy (`8788:9953`) + right `495×410` artwork.
 */
export function LandingStepSlideCard({
  slide,
  index,
  className,
}: LandingStepSlideCardProps) {
  return (
    <div
      className={mergeClasses(
        "flex w-[1000px] shrink-0 items-center",
        className,
      )}
    >
      <div className="flex w-[495px] shrink-0 items-center justify-start">
        <div className="flex w-[471px] shrink-0 flex-col gap-[22px] py-[8px]">
          <p className="text-[18px] font-normal leading-[26px] tracking-[-0.2px] text-black">
            {slide.stepLabel}
          </p>
          <div className="flex flex-col gap-[12px] tracking-[-0.3px]">
            <p className="text-[28px] font-medium leading-[30.8px] text-[#31373d]">
              {slide.heading}
            </p>
            <p className="text-[20px] font-normal leading-[28px] text-[#383838]">
              {slide.description}
            </p>
          </div>
        </div>
      </div>
      <Image
        src={slide.image}
        alt={`${slide.stepLabel}: ${slide.heading}`}
        width={495}
        height={410}
        sizes="495px"
        className="ml-[10px] h-[410px] w-[495px] shrink-0 rounded-[24px] object-cover"
        priority={index === 0}
      />
    </div>
  );
}
